export default __webpack_public_path__ + "static/media/rclubes.f6dafb2c.svg";